import { Component, inject } from '@angular/core';
import { Language } from '../../generic/classes/language';
import { FilterService } from '../../generic/service/filter.service';
import { UserService } from '../../generic/service/user.service';
import { LanguageService } from '../../service/language.service';
import { availableLanguagesArray } from './available.languages.array';
import { RenderLanguageComponent } from './render.language';
import { FormsModule } from '@angular/forms';

/**
 * Select language component
 *
 * @author evandongen
 */
@Component({
    selector: 'language-select',
    styleUrls: [
        './language.select.component.scss',
        '../../../assets/style/_layout.scss',
    ],
    templateUrl: 'language.select.component.html',
    standalone: true,
    imports: [FormsModule, RenderLanguageComponent],
})
export class LanguageSelectComponent {
    private languageService = inject(LanguageService);
    private filterService = inject(FilterService);
    private userService = inject(UserService);

    languages: Array<string>;
    availableLanguages: Language[];
    selectedLanguage: string;

    constructor() {
        this.initLanguages();
    }

    changeLanguage($event) {
        const chosenLanguage = this.availableLanguages.find(
            language => language.shopKey === $event,
        );
        this.languageService.changeLanguage(
            $event,
            chosenLanguage.iso.toLowerCase(),
        );
    }

    /**
     * Shorthand to populate the select with languages
     */
    private initLanguages() {
        this.selectedLanguage = this.filterService.getSelectedLanguage();

        if (!this.selectedLanguage) {
            this.selectedLanguage = this.userService.getUserDefaultLanguage();
        }

        this.availableLanguages = availableLanguagesArray;
        this.languages = this.languageService.getLanguages();

        // set default if not yet set
        if (!this.selectedLanguage && this.languages !== null) {
            this.selectedLanguage = this.languages[0];
        }
    }
}
